import {createAction, createReducer} from '@reduxjs/toolkit';
import initialstate from '../app/initialstate';

const IS_LOADING = 'app/loading';

/**
 * Action creator to set isLoading store slice
 * @param {Boolean} isLoading
 * @param {Array<string>} areas
 */
export const setLoading = createAction(IS_LOADING);

export const loadingReducer = createReducer(initialstate.loading, (builder) => {
	builder.addCase(setLoading, (loading, action) => {
		const areas = action.payload.areas;
		const isLoading = action.payload.isLoading;

		if (Array.isArray(areas)) {
			const updatedAreas = areas.reduce((previous, current) => {
				return {...previous, [current]: isLoading};
			}, loading.areas);

			return {
				areas: updatedAreas
			};
		}

		return loading;
	});
});
